/*
 * @Author: lbh
 * @Date: 2021-01-07 18:12:32
 * @LastEditors: lbh
 * @LastEditTime: 2024-08-22 10:00:53
 * @Description: 存放 緩存的 key . 用來統一key , 便於修改和管理
 */

import logan from "./logan";

let time = () => {
  let date = new Date();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  // 凌晨 5點鐘之前 都算 前一天
  if (hour < 5) {
    day -= 1;
  }
  return `${month}_${day}`;
};
let qr_ = (type) => {
  let q = localStorage.getItem(key.scan_order_qr);
  type = type || localStorage.getItem(key.re_type);
  if (type == 1 || type == 7) {
    return "";
  }
  if (q) {
    return `_${q}`;
  }
  return "";
};
let key = {
  /**
   * 清除上一天的記錄
   */
  clearLoca: () => {
    let app_clear_time = localStorage.getItem(key.app_clear_time);
    let now = time();
    if (app_clear_time != now && app_clear_time) {
      let user_id = localStorage.getItem(key.user_id);
      let user_phone = localStorage.getItem(key.user_phone);
      let app_language = localStorage.getItem(key.app_language);
      let random_word = localStorage.getItem(key.random_word);
      let user_token = localStorage.getItem("user_token");
      let user_sex = localStorage.getItem(key.user_sex);
      let user_name = localStorage.getItem(key.user_name);
      let user_email = localStorage.getItem(key.user_email);
      let user_birthday = localStorage.getItem(key.user_birthday);
      let user_openid = localStorage.getItem("user_openid");

      // 定制app
      let isCoutomApp = localStorage.getItem("isCoutomApp");
      // 用戶信息
      let RICEPON_COUTOM_MEMBER = localStorage.getItem("RICEPON_COUTOM_MEMBER");
      // 主題色
      let coutomAppThemeColor = localStorage.getItem("coutomAppThemeColor");
      // appType
      let coutomAppType = localStorage.getItem("coutomAppType");
      // 語言
      let RICEPON_COUTOM_LANG = localStorage.getItem("RICEPON_COUTOM_LANG");

      let t = {
        old: app_clear_time,
        now: now,
        t: "清除緩存",
      };
      logan.log(t, logan.types.default);
      // * 只刪除 app_ 的, 避免後台收影響
      for (let key in localStorage) {
        if (key.includes("app_")) localStorage.removeItem(key);
      }
      // localStorage.clear();
      if (user_token != "null" && user_token != "undefined" && user_token) {
        if (user_id != "null" && user_id != "undefined" && user_id) {
          localStorage.setItem(key.user_id, user_id);
        }
        if (user_phone != "null" && user_phone != "undefined" && user_phone) {
          localStorage.setItem(key.user_phone, user_phone);
        }
        if (user_token != "null" && user_token != "undefined" && user_token) {
          localStorage.setItem("user_token", user_token);
        }
        if (user_sex) localStorage.setItem(key.user_sex, user_sex);
        if (user_name) localStorage.setItem(key.user_name, user_name);
        if (user_email) localStorage.setItem(key.user_email, user_email);
        if (user_birthday)
          localStorage.setItem(key.user_birthday, user_birthday);
        if (user_openid) localStorage.setItem("user_openid", user_openid);
      }
      if (random_word != "null" && random_word != "undefined" && random_word) {
        localStorage.setItem(key.random_word, random_word);
      }
      if (
        app_language != "null" &&
        app_language != "undefined" &&
        app_language
      ) {
        localStorage.setItem(key.app_language, app_language);
      }

      if (isCoutomApp) {
        localStorage.setItem("isCoutomApp", isCoutomApp);
      }
      // 用戶信息
      if (RICEPON_COUTOM_MEMBER) {
        localStorage.setItem("RICEPON_COUTOM_MEMBER", RICEPON_COUTOM_MEMBER);
      }
      // 主題色
      if (coutomAppThemeColor) {
        localStorage.setItem("coutomAppThemeColor", coutomAppThemeColor);
      }
      // appType
      if (coutomAppType) {
        localStorage.setItem("coutomAppType", coutomAppType);
      }
      // 語言
      if (RICEPON_COUTOM_LANG) {
        localStorage.setItem("RICEPON_COUTOM_LANG", RICEPON_COUTOM_LANG);
      }

      localStorage.setItem(key.app_clear_time, now);
    } else {
      localStorage.setItem(key.app_clear_time, now);
    }
  },
  //用戶id
  user_id: "app_user_id",
  //用戶手機號碼
  user_phone: "app_user_phone",
  user_name: "app_user_name",
  user_sex: "app_user_sex",
  user_birthday: "app_user_birthday",
  user_email: "app_user_email",
  headImg: "app_head_img",
  // 語言
  app_language: "app_language",
  //用戶標識
  random_word: "random_word",
  //當前品牌 id
  brand_id: "app_brand_id",
  //當前餐廳 id
  restaurant_id: "app_restaurant_id",
  // 當前餐廳名稱
  restaurant_name: "app_restaurant_name",
  // 品牌名稱
  brand_name: "app_brandId_name",
  // 點餐人數
  person: "app_person",
  // 掃碼點餐倒計時
  deliveryInterval: "app_deliveryInterval",
  // 掃碼點餐 下單時間
  scan_order_time: "app_scan_order_time",
  // 掃碼點餐二維碼
  scan_order_qr: "app_scan_order_qr",
  // 應用上一次清理緩存的時間
  app_clear_time: "app_clear_time",
  // 自助碼 外帶 堂食
  autoCodeType: "autoCodeType",
  // 自助碼去 地鐵
  autoCodeMap: "autoCodeMap",
  // 餐牌頁的 utl
  app_index_url: () => {
    return `app_index_url_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}`;
  },
  // 餐牌數據
  food_data: () => {
    return `app_foods_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}`;
  },
  // 當前選擇地址
  select_address: "app_select_address",
  //點餐類型
  re_type: "re_type",
  // 餐種
  menu_type: "menu_type",
  // 是否开启叫号保持图片
  isShowScreenshot: (restaurantId, callNumberId) => {
    return `isShowScreenshot_${
      restaurantId || localStorage.getItem(key.restaurant_id)
    }_${callNumberId}_${
      localStorage.getItem(key.user_id) || localStorage.getItem(key.random_word)
    }`;
  },

  // 當前購物車總金額
  app_total_all: (type) => {
    type = type == 10 ? 6 : type;
    return `app_total_all_${localStorage.getItem(key.restaurant_id)}_${
      type || localStorage.getItem(key.re_type)
    }_${time()}${qr_(type)}`;
  },
  //當前購物的餐盒費
  app_lunch_box: (type) => {
    type = type == 10 ? 6 : type;
    return `app_lunch_box_${localStorage.getItem(key.restaurant_id)}_${
      type || localStorage.getItem(key.re_type)
    }_${time()}`;
  },
  // * 當前購物車數據
  app_shop_cart_datas: (type, qrcode) => {
    type = type == 10 ? 6 : type;
    return `app_shop_cart_datas_${localStorage.getItem(key.restaurant_id)}_${
      type || localStorage.getItem(key.re_type)
    }_${time()}${qr_(type)}_${
      qrcode || localStorage.getItem(key.menuQrcodeContent)
    }`;
  },
  menuQrcodeContent: "menuQrcodeContent",
  // * 餐種食品
  app_summary_shop_cart_datas: (type, qrcode) => {
    type = type == 10 ? 6 : type;
    return `app_summary_shop_cart_datas_${localStorage.getItem(
      key.restaurant_id
    )}_${type || localStorage.getItem(key.re_type)}_${time()}${qr_(type)}_${
      qrcode || localStorage.getItem(key.menuQrcodeContent)
    }`;
  },
  // 掃碼點餐 歷史訂單
  app_history_datas: () => {
    return `app_history_datas_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}`;
  },
  // 優惠券
  app_coupon: () => {
    return `app_coupn_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}`;
  },
  /**
   * 下單後的 標識
   */
  add_order_random: () => {
    return `addOrderRandom_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}`;
  },
  // 標題
  app_title: "app_title",
  // 網頁標題
  document_title: "document_title",
  // logo
  app_logo: "app_logo",
  // 主題色
  theme_color: "theme_color",
  // 餐廳 外送服務 狀態
  shipany_status: "shipany_status",
  // 備註
  app_remark: "app_remark",
  // 支付方式
  app_pay_type: "app_pay_type_check",
  // 備註記錄
  remark_history: "app_remark_history",
  // 自助碼服務開啟狀態
  autoCodeStatus: "autoCodeStatus",
  // 餐牌頁 展示 我的訂單 1 展示外送自取 我的訂單
  // menu_show_order: "app_menu_show_order",
  menu_show_order: (t) => {
    return `menu_show_order_${
      t ||
      localStorage.getItem(key.scan_order_qr) ||
      localStorage.getItem(key.re_type)
    }_${time()}`;
  },
  // 地址頁-> 地圖頁 暫存的地址信息
  place_: "app_place_",
  // 當前編輯的地址
  app_place: "app_place",
  // 不在配送範圍的id組
  no_address_id: "app_no_address_ids",
  // 自取 本次的值
  inviteLocaParams: () => {
    return `inviteLocaParams_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}`;
  },
  /**
   * @returns 食品當前下標
   */
  group_index: () => {
    return `menu_group_index_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}`;
  },
  ls_address: "ls_restaurant_address",
  te_coupon: "te_couopn_data",
  country_key: "app_country_data",
  order_detail: "is_order_detail",
  // 固定碼 訂單id
  scan_table_order_id: "scan_table_order_id",
  // * 固定碼 人數
  scan_person: (e) => {
    return `scan_person_${localStorage.getItem(key.restaurant_id)}_${
      e || localStorage.getItem(key.re_type)
    }`;
  },
  // * 送單人數
  order_person(e) {
    return `order_person_${localStorage.getItem(key.restaurant_id)}_${e}`;
  },
  // 掃碼點餐, 送單次數
  orderSendNum: () => {
    return `order_send_num_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  tableName() {
    return `table_name_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  // 掃碼點餐, 點擊送單次數
  orderSendNum1: () => {
    return `order_send_num1_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  // 點擊下一步 記錄次數
  orderSendNum3: () => {
    return `order_send_num3_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  //  點擊 我的訂單 記錄次數
  orderSendNum4: () => {
    return `order_send_num4_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  fixedOrderTime: "fixedOrderTime",
  // 固定碼 支付訂單id
  order_status: "order_status",
  // 服務費
  serviceCharge: () => {
    return `serviceCharge_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  //
  rounding: () => {
    return `rounding_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  roundingDecimal: () => {
    return `roundingDecimal_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  itemDecimals: () => {
    return `itemDecimals_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.re_type)}_${time()}${qr_()}`;
  },
  couponGrouponItem: () => {
    return `couponGrouponItem_${localStorage.getItem(
      key.restaurant_id
    )}_${localStorage.getItem(key.brand_id)}`;
  },
  callNumberInfo: (restaurantId) => {
    return `callNumberInfo_${
      restaurantId || localStorage.getItem(key.restaurant_id)
    }_${
      localStorage.getItem(key.user_id) || localStorage.getItem(key.random_word)
    }`;
  },
  couponType: "couponType",
  shoppingCartConfig: (restaurantId) => {
    return `shoppingCartConfig_${
      restaurantId || localStorage.getItem(key.restaurant_id)
    }`;
  },
  extToken: "extToken",
  // 支付依据
  app_pay_key: () => {
    return `app_pay_key_${localStorage.getItem(key.restaurant_id)}_${time()}`;
  },
};
export default key;
